module.exports = __webpack_public_path__ + "462aacad88147d9872dba22cf5e3d307.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C0000BF1O.png
// module id = 1716
// module chunks = 0